var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStyleNormalTextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59159 9.99931H4.40797C4.25045 9.99931 4.12284 9.87188 4.12284 9.7146V1.8582C4.12284 1.70092 3.99523 1.5735 3.83771 1.5735H1.48508C1.32756 1.5735 1.19995 1.44608 1.19995 1.2888V0.284702C1.19995 0.127422 1.32756 0 1.48508 0H8.51482C8.67234 0 8.79995 0.127422 8.79995 0.284702V1.28915C8.79995 1.44643 8.67234 1.57385 8.51482 1.57385H6.16184C6.00432 1.57385 5.87671 1.70127 5.87671 1.85855V9.7153C5.87671 9.87258 5.7491 10 5.59159 10V9.99931Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleNormalTextIcon);
export default __webpack_public_path__ + "static/media/StyleNormalTextIcon.b9f53abf498eb98de6cf37b29c5a23ce.svg";
export { ForwardRef as ReactComponent };